import React, { useEffect, useState } from 'react';
import { getBasLabels } from '../../../utils/commonUtils';
import './MobileViewShowDealer.scss';

export default function MobileViewShowDealer({ dealer, dealerSelected, closeMobView }) {
  const labels = getBasLabels();
  return (
    <div className="mob_holder">
      <div className="mob_dealer_name_container">
        <span className="mob_dealer_name">{dealer.Name}</span>
        <span className="icon-chevron-down" onClick={closeMobView}></span>
      </div>
      <div className="mob_img_container">
        <img className="mob_img" src={dealer.DistributorImagePath} />
      </div>
      <div className="address_phone_mail">
        <div className="address_details">
          <div className="icon_label">
            <span className="icon-GENS_pin"></span>
            <span className="label">{labels.addressTitle}</span>
          </div>
          <div className="address">{dealer.ServiceAddressStreet}</div>
          <div className="address">{dealer.ServiceAddressPostalCode}</div>
          <div className="get_directions_container">
            <a
              className="get-direction-link"
              href={`https://www.google.com/maps?q=${dealer.Latitude},${dealer.Longitude}`}
              target="_blank"
              rel="noopener noreferrer">
              {labels?.getDirections}
            </a>
          </div>
        </div>
        <div className="call_details">
          <span className="icon-GENS_phone"></span>
          <span className="phone">{dealer.Phone}</span>
        </div>
        <div className="mail_details">
          <span className="icon-GENS_email"></span>
          <span className="email">{dealer.ServiceEmail}</span>
        </div>
      </div>
      <div className="service_hours_container">
        <div className="service_icon_label">
          <span className="icon-GENS_store"></span>
          <span className="service_label">{labels.serviceHoursTitle}</span>
        </div>
        <div className="service_hours_container">
          {dealer.Hours.Service.Days.map((serviceHour) => {
            return (
              <div className="day_item" key={serviceHour.Weekday}>
                <span className="weekday">{serviceHour.Weekday.substring(0, 3)}</span>
                <span className="hours">
                  {serviceHour.Start} {` - ${serviceHour.End}`}
                </span>
              </div>
            );
          })}
        </div>
      </div>
      <div className="select_btn_container">
        <button className="select_dealer_btn" onClick={() => dealerSelected(dealer)}>
          {labels.selectLabel}
        </button>
      </div>
    </div>
  );
}
